// src/utils/MockupGenerator.jsx
import {
  Box,
  Container,
  Paper,
  Typography,
  Avatar,
  Grid,
  Card,
  CardContent,
  LinearProgress,
  Chip,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Divider
} from '@mui/material';
import {
  TrendingUp,
  People,
  EventAvailable,
  AttachMoney,
  VideoCall,
  CheckCircle
} from '@mui/icons-material';

// Este componente es solo para generar capturas de pantalla
// Accede a él en: /mockup-generator

const MockupGenerator = () => {
  return (
    <Box sx={{ bgcolor: '#f5f5f5', minHeight: '100vh', p: 3 }}>
      <Container maxWidth="xl">
        <Typography variant="h4" gutterBottom>
          Generador de Mockups - Toma screenshots de cada sección
        </Typography>
        
        {/* MOCKUP 1: DASHBOARD */}
        <Paper 
          id="mockup-dashboard" 
          elevation={3} 
          sx={{ p: 3, mb: 4, borderRadius: 3 }}
        >
          <Typography variant="h5" fontWeight="bold" gutterBottom>
            Dashboard
          </Typography>
          
          <Grid container spacing={3} sx={{ mb: 3 }}>
            <Grid item xs={12} sm={6} md={3}>
              <Card sx={{ background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', color: 'white' }}>
                <CardContent>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Box>
                      <Typography variant="body2" sx={{ opacity: 0.9 }}>
                        Pacientes Total
                      </Typography>
                      <Typography variant="h4" fontWeight="bold">
                        1,284
                      </Typography>
                      <Typography variant="caption" sx={{ opacity: 0.8 }}>
                        +12% este mes
                      </Typography>
                    </Box>
                    <Avatar sx={{ bgcolor: 'rgba(255,255,255,0.2)', width: 56, height: 56 }}>
                      <People />
                    </Avatar>
                  </Box>
                </CardContent>
              </Card>
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <Card sx={{ background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)', color: 'white' }}>
                <CardContent>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Box>
                      <Typography variant="body2" sx={{ opacity: 0.9 }}>
                        Citas Hoy
                      </Typography>
                      <Typography variant="h4" fontWeight="bold">
                        24
                      </Typography>
                      <Typography variant="caption" sx={{ opacity: 0.8 }}>
                        6 pendientes
                      </Typography>
                    </Box>
                    <Avatar sx={{ bgcolor: 'rgba(255,255,255,0.2)', width: 56, height: 56 }}>
                      <EventAvailable />
                    </Avatar>
                  </Box>
                </CardContent>
              </Card>
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <Card sx={{ background: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)', color: 'white' }}>
                <CardContent>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Box>
                      <Typography variant="body2" sx={{ opacity: 0.9 }}>
                        Ingresos Mes
                      </Typography>
                      <Typography variant="h4" fontWeight="bold">
                        $45.2K
                      </Typography>
                      <Typography variant="caption" sx={{ opacity: 0.8 }}>
                        +8% vs anterior
                      </Typography>
                    </Box>
                    <Avatar sx={{ bgcolor: 'rgba(255,255,255,0.2)', width: 56, height: 56 }}>
                      <AttachMoney />
                    </Avatar>
                  </Box>
                </CardContent>
              </Card>
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <Card sx={{ background: 'linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)', color: 'white' }}>
                <CardContent>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Box>
                      <Typography variant="body2" sx={{ opacity: 0.9 }}>
                        Satisfacción
                      </Typography>
                      <Typography variant="h4" fontWeight="bold">
                        98%
                      </Typography>
                      <Typography variant="caption" sx={{ opacity: 0.8 }}>
                        Excelente
                      </Typography>
                    </Box>
                    <Avatar sx={{ bgcolor: 'rgba(255,255,255,0.2)', width: 56, height: 56 }}>
                      <TrendingUp />
                    </Avatar>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          </Grid>

          <Grid container spacing={3}>
            <Grid item xs={12} md={8}>
              <Paper sx={{ p: 3, height: '100%' }}>
                <Typography variant="h6" fontWeight="bold" gutterBottom>
                  Actividad Reciente
                </Typography>
                <List>
                  {[
                    { name: 'María García', action: 'Consulta completada', time: 'Hace 5 min', avatar: 'M', color: '#667eea' },
                    { name: 'Juan Pérez', action: 'Nueva cita programada', time: 'Hace 15 min', avatar: 'J', color: '#f093fb' },
                    { name: 'Ana López', action: 'Resultados de laboratorio', time: 'Hace 1 hora', avatar: 'A', color: '#4facfe' },
                    { name: 'Carlos Ruiz', action: 'Receta digital enviada', time: 'Hace 2 horas', avatar: 'C', color: '#43e97b' },
                  ].map((item, index) => (
                    <Box key={index}>
                      <ListItem>
                        <ListItemAvatar>
                          <Avatar sx={{ bgcolor: item.color }}>{item.avatar}</Avatar>
                        </ListItemAvatar>
                        <ListItemText
                          primary={item.name}
                          secondary={
                            <Box>
                              <Typography variant="body2" color="text.secondary">
                                {item.action}
                              </Typography>
                              <Typography variant="caption" color="text.secondary">
                                {item.time}
                              </Typography>
                            </Box>
                          }
                        />
                      </ListItem>
                      {index < 3 && <Divider variant="inset" component="li" />}
                    </Box>
                  ))}
                </List>
              </Paper>
            </Grid>

            <Grid item xs={12} md={4}>
              <Paper sx={{ p: 3, height: '100%' }}>
                <Typography variant="h6" fontWeight="bold" gutterBottom>
                  Próximas Citas
                </Typography>
                <List dense>
                  {[
                    { time: '09:00', patient: 'Pedro Martínez', type: 'Consulta General' },
                    { time: '10:30', patient: 'Laura Fernández', type: 'Control' },
                    { time: '12:00', patient: 'Roberto Silva', type: 'Telemedicina' },
                    { time: '14:00', patient: 'Sofia Torres', type: 'Primera Vez' },
                  ].map((cita, index) => (
                    <ListItem key={index} sx={{ px: 0 }}>
                      <Chip 
                        label={cita.time} 
                        size="small" 
                        color="primary" 
                        sx={{ mr: 2, minWidth: 60 }}
                      />
                      <ListItemText
                        primary={cita.patient}
                        secondary={cita.type}
                      />
                    </ListItem>
                  ))}
                </List>
              </Paper>
            </Grid>
          </Grid>
        </Paper>

        {/* MOCKUP 2: CALENDARIO */}
        <Paper 
          id="mockup-calendar" 
          elevation={3} 
          sx={{ p: 3, mb: 4, borderRadius: 3 }}
        >
          <Typography variant="h5" fontWeight="bold" gutterBottom sx={{ mb: 3 }}>
            Calendario de Citas
          </Typography>
          
          <Grid container spacing={2}>
            {/* Calendario simplificado */}
            <Grid item xs={12}>
              <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', gap: 1, mb: 2 }}>
                {['Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb', 'Dom'].map((day) => (
                  <Box key={day} sx={{ textAlign: 'center', fontWeight: 'bold', py: 1 }}>
                    {day}
                  </Box>
                ))}
              </Box>
              
              <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', gap: 1 }}>
                {Array.from({ length: 35 }, (_, i) => {
                  const hasAppointment = [5, 6, 8, 12, 13, 15, 19, 20, 22, 26].includes(i);
                  const isToday = i === 13;
                  return (
                    <Paper
                      key={i}
                      elevation={isToday ? 4 : 1}
                      sx={{
                        p: 2,
                        textAlign: 'center',
                        minHeight: 80,
                        bgcolor: isToday ? 'primary.main' : hasAppointment ? 'action.hover' : 'background.paper',
                        color: isToday ? 'white' : 'text.primary',
                        cursor: 'pointer',
                        transition: 'all 0.3s',
                        '&:hover': {
                          transform: 'scale(1.05)',
                          boxShadow: 3
                        }
                      }}
                    >
                      <Typography variant="h6" fontWeight={isToday ? 'bold' : 'normal'}>
                        {i + 1}
                      </Typography>
                      {hasAppointment && (
                        <Chip
                          label={Math.floor(Math.random() * 8) + 1}
                          size="small"
                          sx={{
                            mt: 1,
                            height: 20,
                            fontSize: '0.7rem',
                            bgcolor: isToday ? 'rgba(255,255,255,0.3)' : 'primary.main',
                            color: isToday ? 'white' : 'white'
                          }}
                        />
                      )}
                    </Paper>
                  );
                })}
              </Box>
            </Grid>
          </Grid>
        </Paper>

        {/* MOCKUP 3: PACIENTES */}
        <Paper 
          id="mockup-patients" 
          elevation={3} 
          sx={{ p: 3, mb: 4, borderRadius: 3 }}
        >
          <Typography variant="h5" fontWeight="bold" gutterBottom sx={{ mb: 3 }}>
            Lista de Pacientes
          </Typography>
          
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow sx={{ bgcolor: 'primary.main' }}>
                  <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Paciente</TableCell>
                  <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Edad</TableCell>
                  <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Última Visita</TableCell>
                  <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Diagnóstico</TableCell>
                  <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Estado</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {[
                  { name: 'María González', age: 45, visit: '15/02/2024', diagnosis: 'Diabetes Tipo 2', status: 'Activo' },
                  { name: 'Juan Martínez', age: 32, visit: '14/02/2024', diagnosis: 'Hipertensión', status: 'Seguimiento' },
                  { name: 'Ana López', age: 28, visit: '13/02/2024', diagnosis: 'Control Prenatal', status: 'Activo' },
                  { name: 'Carlos Ruiz', age: 55, visit: '12/02/2024', diagnosis: 'Artritis', status: 'Tratamiento' },
                  { name: 'Laura Torres', age: 41, visit: '11/02/2024', diagnosis: 'Migraña', status: 'Activo' },
                  { name: 'Pedro Sánchez', age: 67, visit: '10/02/2024', diagnosis: 'Cardiopatía', status: 'Control' },
                ].map((patient, index) => (
                  <TableRow key={index} hover sx={{ '&:hover': { bgcolor: 'action.hover' } }}>
                    <TableCell>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                        <Avatar sx={{ bgcolor: 'primary.main' }}>
                          {patient.name.charAt(0)}
                        </Avatar>
                        <Typography fontWeight="medium">{patient.name}</Typography>
                      </Box>
                    </TableCell>
                    <TableCell>{patient.age} años</TableCell>
                    <TableCell>{patient.visit}</TableCell>
                    <TableCell>{patient.diagnosis}</TableCell>
                    <TableCell>
                      <Chip
                        label={patient.status}
                        size="small"
                        color={
                          patient.status === 'Activo' ? 'success' :
                          patient.status === 'Seguimiento' ? 'info' :
                          patient.status === 'Tratamiento' ? 'warning' : 'default'
                        }
                      />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>

        {/* MOCKUP 4: TELEMEDICINA */}
        <Paper 
          id="mockup-telemedicine" 
          elevation={3} 
          sx={{ p: 3, mb: 4, borderRadius: 3, bgcolor: '#1a1a2e' }}
        >
          <Typography variant="h5" fontWeight="bold" gutterBottom sx={{ mb: 3, color: 'white' }}>
            Consulta de Telemedicina
          </Typography>
          
          <Grid container spacing={3}>
            <Grid item xs={12} md={8}>
              <Box
                sx={{
                  bgcolor: '#0f3460',
                  borderRadius: 2,
                  aspectRatio: '16/9',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  position: 'relative',
                  overflow: 'hidden'
                }}
              >
                <Box
                  sx={{
                    width: '100%',
                    height: '100%',
                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}
                >
                  <Avatar sx={{ width: 120, height: 120, fontSize: '3rem', bgcolor: 'rgba(255,255,255,0.2)' }}>
                    MG
                  </Avatar>
                </Box>
                
                {/* Video del doctor (pequeño) */}
                <Box
                  sx={{
                    position: 'absolute',
                    bottom: 16,
                    right: 16,
                    width: 180,
                    height: 120,
                    borderRadius: 2,
                    overflow: 'hidden',
                    bgcolor: '#16213e',
                    border: '2px solid white',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}
                >
                  <Avatar sx={{ width: 60, height: 60, bgcolor: 'primary.main' }}>
                    Dr
                  </Avatar>
                </Box>

                {/* Controles */}
                <Box
                  sx={{
                    position: 'absolute',
                    bottom: 16,
                    left: '50%',
                    transform: 'translateX(-50%)',
                    display: 'flex',
                    gap: 2,
                    bgcolor: 'rgba(0,0,0,0.6)',
                    backdropFilter: 'blur(10px)',
                    borderRadius: 10,
                    p: 1
                  }}
                >
                  {[
                    { icon: '🎤', label: 'Mic' },
                    { icon: '📹', label: 'Video' },
                    { icon: '🖥️', label: 'Compartir' },
                    { icon: '💬', label: 'Chat' },
                    { icon: '❌', label: 'Colgar', color: 'error.main' }
                  ].map((btn, index) => (
                    <Avatar
                      key={index}
                      sx={{
                        width: 48,
                        height: 48,
                        bgcolor: btn.color || 'rgba(255,255,255,0.2)',
                        cursor: 'pointer',
                        '&:hover': {
                          bgcolor: btn.color || 'rgba(255,255,255,0.3)'
                        }
                      }}
                    >
                      {btn.icon}
                    </Avatar>
                  ))}
                </Box>

                {/* Timer */}
                <Chip
                  label="15:34"
                  sx={{
                    position: 'absolute',
                    top: 16,
                    left: 16,
                    bgcolor: 'rgba(255,0,0,0.8)',
                    color: 'white',
                    fontWeight: 'bold'
                  }}
                />
              </Box>
            </Grid>

            <Grid item xs={12} md={4}>
              <Paper sx={{ p: 2, height: '100%', bgcolor: '#16213e' }}>
                <Typography variant="h6" fontWeight="bold" gutterBottom sx={{ color: 'white' }}>
                  Información del Paciente
                </Typography>
                <Divider sx={{ mb: 2, borderColor: 'rgba(255,255,255,0.1)' }} />
                
                <Box sx={{ color: 'white' }}>
                  <Typography variant="body2" color="rgba(255,255,255,0.7)" gutterBottom>
                    Nombre
                  </Typography>
                  <Typography variant="body1" fontWeight="bold" sx={{ mb: 2 }}>
                    María González Pérez
                  </Typography>

                  <Typography variant="body2" color="rgba(255,255,255,0.7)" gutterBottom>
                    Edad
                  </Typography>
                  <Typography variant="body1" fontWeight="bold" sx={{ mb: 2 }}>
                    45 años
                  </Typography>

                  <Typography variant="body2" color="rgba(255,255,255,0.7)" gutterBottom>
                    Motivo de Consulta
                  </Typography>
                  <Typography variant="body1" fontWeight="bold" sx={{ mb: 2 }}>
                    Control de Diabetes
                  </Typography>

                  <Typography variant="body2" color="rgba(255,255,255,0.7)" gutterBottom>
                    Alergias
                  </Typography>
                  <Typography variant="body1" fontWeight="bold" sx={{ mb: 2 }}>
                    Penicilina
                  </Typography>

                  <Divider sx={{ my: 2, borderColor: 'rgba(255,255,255,0.1)' }} />

                  <Typography variant="body2" color="rgba(255,255,255,0.7)" gutterBottom>
                    Notas Rápidas
                  </Typography>
                  <Box
                    component="textarea"
                    sx={{
                      width: '100%',
                      minHeight: 100,
                      bgcolor: 'rgba(0,0,0,0.3)',
                      color: 'white',
                      border: '1px solid rgba(255,255,255,0.1)',
                      borderRadius: 1,
                      p: 1,
                      fontFamily: 'inherit',
                      fontSize: '0.875rem',
                      resize: 'vertical',
                      '&:focus': {
                        outline: 'none',
                        borderColor: 'primary.main'
                      }
                    }}
                    placeholder="Escribe notas de la consulta..."
                  />

                  <Box sx={{ mt: 2, display: 'flex', gap: 1 }}>
                    <Chip
                      icon={<CheckCircle />}
                      label="Receta Digital"
                      size="small"
                      sx={{ bgcolor: 'success.main', color: 'white' }}
                    />
                    <Chip
                      icon={<CheckCircle />}
                      label="Estudios"
                      size="small"
                      sx={{ bgcolor: 'info.main', color: 'white' }}
                    />
                  </Box>
                </Box>
              </Paper>
            </Grid>
          </Grid>
        </Paper>

        {/* MOCKUP 5: FINANZAS */}
        <Paper 
          id="mockup-finances" 
          elevation={3} 
          sx={{ p: 3, mb: 4, borderRadius: 3 }}
        >
          <Typography variant="h5" fontWeight="bold" gutterBottom sx={{ mb: 3 }}>
            Control Financiero
          </Typography>
          
          <Grid container spacing={3}>
            {/* Resumen financiero */}
            <Grid item xs={12} md={4}>
              <Card sx={{ background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', color: 'white', height: '100%' }}>
                <CardContent>
                  <Typography variant="h6" gutterBottom sx={{ opacity: 0.9 }}>
                    Ingresos del Mes
                  </Typography>
                  <Typography variant="h3" fontWeight="bold" gutterBottom>
                    $45,280
                  </Typography>
                  <Typography variant="body2" sx={{ mb: 2, opacity: 0.8 }}>
                    +8.2% vs mes anterior
                  </Typography>
                  <LinearProgress 
                    variant="determinate" 
                    value={82} 
                    sx={{ 
                      height: 8, 
                      borderRadius: 4,
                      bgcolor: 'rgba(255,255,255,0.3)',
                      '& .MuiLinearProgress-bar': {
                        bgcolor: 'white'
                      }
                    }} 
                  />
                  <Typography variant="caption" sx={{ mt: 1, display: 'block', opacity: 0.8 }}>
                    82% de la meta mensual ($55,000)
                  </Typography>
                </CardContent>
              </Card>
            </Grid>

            <Grid item xs={12} md={4}>
              <Card sx={{ background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)', color: 'white', height: '100%' }}>
                <CardContent>
                  <Typography variant="h6" gutterBottom sx={{ opacity: 0.9 }}>
                    Gastos del Mes
                  </Typography>
                  <Typography variant="h3" fontWeight="bold" gutterBottom>
                    $18,450
                  </Typography>
                  <Typography variant="body2" sx={{ mb: 2, opacity: 0.8 }}>
                    -3.5% vs mes anterior
                  </Typography>
                  <LinearProgress 
                    variant="determinate" 
                    value={65} 
                    sx={{ 
                      height: 8, 
                      borderRadius: 4,
                      bgcolor: 'rgba(255,255,255,0.3)',
                      '& .MuiLinearProgress-bar': {
                        bgcolor: 'white'
                      }
                    }} 
                  />
                  <Typography variant="caption" sx={{ mt: 1, display: 'block', opacity: 0.8 }}>
                    65% del presupuesto mensual
                  </Typography>
                </CardContent>
              </Card>
            </Grid>

            <Grid item xs={12} md={4}>
              <Card sx={{ background: 'linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)', color: 'white', height: '100%' }}>
                <CardContent>
                  <Typography variant="h6" gutterBottom sx={{ opacity: 0.9 }}>
                    Ganancia Neta
                  </Typography>
                  <Typography variant="h3" fontWeight="bold" gutterBottom>
                    $26,830
                  </Typography>
                  <Typography variant="body2" sx={{ mb: 2, opacity: 0.8 }}>
                    Margen: 59.2%
                  </Typography>
                  <LinearProgress 
                    variant="determinate" 
                    value={90} 
                    sx={{ 
                      height: 8, 
                      borderRadius: 4,
                      bgcolor: 'rgba(255,255,255,0.3)',
                      '& .MuiLinearProgress-bar': {
                        bgcolor: 'white'
                      }
                    }} 
                  />
                  <Typography variant="caption" sx={{ mt: 1, display: 'block', opacity: 0.8 }}>
                    Excelente desempeño financiero
                  </Typography>
                </CardContent>
              </Card>
            </Grid>

            {/* Gráfico de barras simulado */}
            <Grid item xs={12} md={8}>
              <Paper sx={{ p: 3 }}>
                <Typography variant="h6" fontWeight="bold" gutterBottom>
                  Ingresos Mensuales 2024
                </Typography>
                <Box sx={{ display: 'flex', alignItems: 'flex-end', gap: 1, height: 250, mt: 3 }}>
                  {[
                    { month: 'Ene', value: 35, amount: 35000 },
                    { month: 'Feb', value: 45, amount: 45280 },
                    { month: 'Mar', value: 30, amount: 30000 },
                    { month: 'Abr', value: 50, amount: 50000 },
                    { month: 'May', value: 55, amount: 55000 },
                    { month: 'Jun', value: 48, amount: 48000 },
                    { month: 'Jul', value: 60, amount: 60000 },
                    { month: 'Ago', value: 52, amount: 52000 },
                    { month: 'Sep', value: 58, amount: 58000 },
                    { month: 'Oct', value: 65, amount: 65000 },
                    { month: 'Nov', value: 70, amount: 70000 },
                    { month: 'Dic', value: 75, amount: 75000 },
                  ].map((item, index) => (
                    <Box 
                      key={index} 
                      sx={{ 
                        flex: 1, 
                        display: 'flex', 
                        flexDirection: 'column', 
                        alignItems: 'center',
                        gap: 1
                      }}
                    >
                      <Chip
                        label={`$${item.amount / 1000}K`}
                        size="small"
                        sx={{ 
                          fontSize: '0.65rem',
                          height: 20,
                          bgcolor: 'primary.main',
                          color: 'white'
                        }}
                      />
                      <Box
                        sx={{
                          width: '100%',
                          height: `${(item.value / 75) * 100}%`,
                          background: `linear-gradient(to top, #667eea, #764ba2)`,
                          borderRadius: 1,
                          transition: 'all 0.3s',
                          cursor: 'pointer',
                          '&:hover': {
                            transform: 'scaleY(1.05)',
                            filter: 'brightness(1.2)'
                          }
                        }}
                      />
                      <Typography variant="caption" fontWeight="bold">
                        {item.month}
                      </Typography>
                    </Box>
                  ))}
                </Box>
              </Paper>
            </Grid>

            {/* Últimas transacciones */}
            <Grid item xs={12} md={4}>
              <Paper sx={{ p: 3 }}>
                <Typography variant="h6" fontWeight="bold" gutterBottom>
                  Últimas Transacciones
                </Typography>
                <List dense>
                  {[
                    { type: 'Ingreso', desc: 'Consulta - María G.', amount: '+$800', color: 'success.main' },
                    { type: 'Ingreso', desc: 'Consulta - Juan P.', amount: '+$800', color: 'success.main' },
                    { type: 'Gasto', desc: 'Material médico', amount: '-$450', color: 'error.main' },
                    { type: 'Ingreso', desc: 'Consulta - Ana L.', amount: '+$800', color: 'success.main' },
                    { type: 'Gasto', desc: 'Servicios públicos', amount: '-$280', color: 'error.main' },
                    { type: 'Ingreso', desc: 'Consulta - Carlos R.', amount: '+$800', color: 'success.main' },
                  ].map((trans, index) => (
                    <ListItem 
                      key={index}
                      sx={{ 
                        px: 0, 
                        py: 1,
                        borderBottom: index < 5 ? '1px solid' : 'none',
                        borderColor: 'divider'
                      }}
                    >
                      <ListItemText
                        primary={
                          <Typography variant="body2" fontWeight="medium">
                            {trans.desc}
                          </Typography>
                        }
                        secondary={
                          <Typography variant="caption" color="text.secondary">
                            {trans.type}
                          </Typography>
                        }
                      />
                      <Typography 
                        variant="body2" 
                        fontWeight="bold"
                        sx={{ color: trans.color }}
                      >
                        {trans.amount}
                      </Typography>
                    </ListItem>
                  ))}
                </List>
              </Paper>
            </Grid>

            {/* Distribución de gastos */}
            <Grid item xs={12}>
              <Paper sx={{ p: 3 }}>
                <Typography variant="h6" fontWeight="bold" gutterBottom>
                  Distribución de Gastos
                </Typography>
                <Grid container spacing={2} sx={{ mt: 1 }}>
                  {[
                    { category: 'Material Médico', amount: 6500, percent: 35, color: '#667eea' },
                    { category: 'Servicios', amount: 4200, percent: 23, color: '#f093fb' },
                    { category: 'Nómina', amount: 5100, percent: 28, color: '#4facfe' },
                    { category: 'Otros', amount: 2650, percent: 14, color: '#43e97b' },
                  ].map((item, index) => (
                    <Grid item xs={12} sm={6} md={3} key={index}>
                      <Box>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                          <Typography variant="body2" fontWeight="medium">
                            {item.category}
                          </Typography>
                          <Typography variant="body2" fontWeight="bold">
                            {item.percent}%
                          </Typography>
                        </Box>
                        <LinearProgress
                          variant="determinate"
                          value={item.percent}
                          sx={{
                            height: 10,
                            borderRadius: 5,
                            bgcolor: 'action.hover',
                            '& .MuiLinearProgress-bar': {
                              bgcolor: item.color,
                              borderRadius: 5
                            }
                          }}
                        />
                        <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5, display: 'block' }}>
                          ${item.amount.toLocaleString()}
                        </Typography>
                      </Box>
                    </Grid>
                  ))}
                </Grid>
              </Paper>
            </Grid>
          </Grid>
        </Paper>

      </Container>
    </Box>
  );
};

export default MockupGenerator;